import { render, staticRenderFns } from "./KYCPromptDialog.vue?vue&type=template&id=c8a5c816&scoped=true"
import script from "./KYCPromptDialog.vue?vue&type=script&lang=js"
export * from "./KYCPromptDialog.vue?vue&type=script&lang=js"
import style0 from "./KYCPromptDialog.vue?vue&type=style&index=0&id=c8a5c816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a5c816",
  null
  
)

export default component.exports